"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VariablesConfigParser = void 0;
class VariablesConfigParser {
    /**
     * Parse VariablesConfig.md content and return structured configuration
     */
    static parseVariablesConfig(content) {
        const lines = content.split('\n');
        const config = {
            userVariables: [],
            mandatoryVariables: {
                player: [],
                character: []
            }
        };
        let currentSection = null;
        let currentSubsection = null;
        for (let i = 0; i < lines.length; i++) {
            const line = lines[i].trim();
            // Skip empty lines and comments (but not section headers)
            if (!line || (line.startsWith('#') && !line.startsWith('##'))) {
                continue;
            }
            // Check for section headers
            if (line.startsWith('## ')) {
                const sectionName = line.substring(3).trim();
                if (sectionName === 'User Variables') {
                    currentSection = 'user';
                    currentSubsection = null;
                }
                else if (sectionName === 'Mandatory Variables') {
                    currentSection = 'mandatory';
                    currentSubsection = null;
                }
                else {
                    currentSection = null;
                    currentSubsection = null;
                }
                continue;
            }
            // Check for subsection headers
            if (line.startsWith('### ')) {
                const subsectionName = line.substring(4).trim();
                if (currentSection === 'mandatory') {
                    if (subsectionName === 'Player Variables') {
                        currentSubsection = 'player';
                    }
                    else if (subsectionName === 'Character Variables') {
                        currentSubsection = 'character';
                    }
                    else {
                        currentSubsection = null;
                    }
                }
                else {
                    currentSubsection = null;
                }
                continue;
            }
            // Check for Variables: block
            if (line === 'Variables:') {
                // Variables block starts, continue to next line
                continue;
            }
            // Parse variable declarations
            if (this.isVariableDeclaration(line)) {
                const variable = this.parseVariableDeclaration(line, currentSection || '');
                if (variable) {
                    if (currentSection === 'user') {
                        variable.ownerScope = 'user';
                        config.userVariables.push(variable);
                    }
                    else if (currentSection === 'mandatory' && currentSubsection) {
                        if (currentSubsection === 'player') {
                            variable.ownerScope = 'player';
                            config.mandatoryVariables.player.push(variable);
                        }
                        else if (currentSubsection === 'character') {
                            variable.ownerScope = 'character';
                            config.mandatoryVariables.character.push(variable);
                        }
                    }
                }
            }
        }
        return config;
    }
    /**
     * Check if a line is a variable declaration
     */
    static isVariableDeclaration(line) {
        // Pattern: type name: "description" = value
        const variablePattern = /^\s*(string|number|boolean|stack)\s+\w+:\s*"[^"]*"\s*=\s*.+/;
        return variablePattern.test(line);
    }
    /**
     * Parse a single variable declaration line
     */
    static parseVariableDeclaration(line, ownerScope) {
        try {
            // Pattern: type name: "description" = value
            const match = line.match(/^\s*(string|number|boolean|stack)\s+(\w+):\s*"([^"]*)"\s*=\s*(.+)$/);
            if (!match) {
                return null;
            }
            const [, type, name, description, defaultValueStr] = match;
            // Validate type
            if (!['string', 'number', 'boolean', 'stack'].includes(type)) {
                throw new Error(`Invalid variable type: ${type}`);
            }
            // Validate name format
            if (!/^[a-z][a-z0-9_]*$/.test(name)) {
                throw new Error(`Invalid variable name format: ${name}`);
            }
            // Validate user variable naming convention
            if (ownerScope === 'user' && !name.startsWith('user_')) {
                throw new Error(`User variables must start with 'user_' prefix: ${name}`);
            }
            // Parse default value based on type
            let defaultValue;
            switch (type) {
                case 'string':
                    // Remove surrounding quotes if present
                    let stringValue = defaultValueStr.trim();
                    if (stringValue.startsWith('"') && stringValue.endsWith('"')) {
                        stringValue = stringValue.slice(1, -1);
                    }
                    defaultValue = stringValue;
                    break;
                case 'stack':
                    // Stack type: default value should be JSON array string or empty array
                    let stackValue = defaultValueStr.trim();
                    if (stackValue === '' || stackValue === '[]') {
                        defaultValue = '[]';
                    }
                    else if (stackValue.startsWith('[') && stackValue.endsWith(']')) {
                        // Already a JSON array string
                        defaultValue = stackValue;
                    }
                    else {
                        // If it's quoted, remove quotes
                        if (stackValue.startsWith('"') && stackValue.endsWith('"')) {
                            stackValue = stackValue.slice(1, -1);
                        }
                        // Validate it's a JSON array
                        try {
                            const parsed = JSON.parse(stackValue);
                            if (!Array.isArray(parsed)) {
                                throw new Error(`Stack default value must be a JSON array: ${stackValue}`);
                            }
                            defaultValue = stackValue;
                        }
                        catch (e) {
                            // If not valid JSON, default to empty array
                            defaultValue = '[]';
                        }
                    }
                    break;
                case 'number':
                    const numValue = parseFloat(defaultValueStr.trim());
                    if (isNaN(numValue)) {
                        throw new Error(`Invalid number value: ${defaultValueStr}`);
                    }
                    defaultValue = numValue;
                    break;
                case 'boolean':
                    const boolValue = defaultValueStr.trim().toLowerCase();
                    if (boolValue === 'true') {
                        defaultValue = true;
                    }
                    else if (boolValue === 'false') {
                        defaultValue = false;
                    }
                    else {
                        throw new Error(`Invalid boolean value: ${defaultValueStr}`);
                    }
                    break;
                default:
                    throw new Error(`Unsupported type: ${type}`);
            }
            return {
                name,
                type: type,
                description,
                defaultValue,
                ownerScope: 'user' // Will be overridden by caller
            };
        }
        catch (error) {
            console.error(`Error parsing variable declaration: ${line}`, error);
            return null;
        }
    }
    /**
     * Load VariablesConfig.md from file system
     */
    static async loadVariablesConfig(configPath) {
        try {
            const fs = await Promise.resolve().then(() => __importStar(require('fs/promises')));
            const content = await fs.readFile(configPath, 'utf-8');
            return this.parseVariablesConfig(content);
        }
        catch (error) {
            console.error(`Error loading VariablesConfig.md from ${configPath}:`, error);
            // Return default empty config
            return {
                userVariables: [],
                mandatoryVariables: {
                    player: [],
                    character: []
                }
            };
        }
    }
}
exports.VariablesConfigParser = VariablesConfigParser;
//# sourceMappingURL=VariablesConfigParser.js.map